// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatMessageForm_wrapper__2NDnk","icon":"ChatMessageForm_icon__2Fv_-","input":"ChatMessageForm_input__3L5Jl","locationButton":"ChatMessageForm_locationButton__3_m1K"};